import { Link } from "react-router-dom";
import Typography from "@mv-components/Typography/Typography";
import { Grid } from "@mui/material";
import styles from "./styles";
import useStyles from "@hooks/useStyle";
import { MvLinkPropsInterface } from "@mv-components/types";

const CustomLink = (props: MvLinkPropsInterface) => {
	const { path = "", label, classToAdd, icon, onClick } = props;
	const { classes } = useStyles(styles) as any;
	return (
		<Link to={path} className={classToAdd ? classes[classToAdd] : ""} onClick={onClick}>
			<Grid container display="flex" direction="row" gap="5px">
				{icon && icon}
				<Typography fontSize="14px" color="primary">
					{label}
				</Typography>
			</Grid>
		</Link>
	);
};

export default CustomLink;
